module.exports = {"140621100":"玉井镇","140621101":"北周庄镇","140621102":"古城镇","140621103":"岱岳镇","140621104":"广武镇","140621200":"吴马营乡","140621201":"马营乡","140621202":"下喇叭乡","140621203":"合盛堡乡","140621205":"安荣乡","140621206":"薛圐圙乡","140621209":"马营庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140621.json
// module id = 403
// module chunks = 0